<!--  -->
<template>
  <div>
    <div>
      <el-form ref="ruleForm" :model="parameter" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="活动名称" prop="title">
          <el-input v-model="parameter.title" v-model.trim="parameter.title" style="width:300px" @input="parameter.title = parameter.title.replace(reg, '')" />
        </el-form-item>
        <el-form-item label="期限选择">
          <el-select v-model="time_type" placeholder="请选择">
            <el-option
              v-for="item in timeoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
          <el-input v-model="parameter.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="parameter.appoint_day = parameter.appoint_day.replace(/[^A-z0-9]/, '')" />
        </el-form-item>
        <el-form-item v-if="time_type === 1" label="活动时间" prop="date">
          <el-date-picker
            v-model="parameter.date"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:410px"
            :clearable="false"
            :picker-options="pickerOptions"
            @change="datavalue"
          />

        </el-form-item>
        <el-form-item label="会员时长" prop="vip_duration">
          <el-select v-model="parameter.vip_duration" placeholder="请选择">
            <el-option
              v-for="item in [{value: '一年', id: 1}, {value: '二年', id: 2},{value: '三年', id: 3},{value: '四年', id: 4},{value: '五年', id: 5}]"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="活动价格" prop="recharge_amount">
          <el-input v-model="parameter.recharge_amount" style="width:300px" :placeholder="`活动价格范围(${parameter.vip_duration * 300}-5000)`" type="number" @blur="chagerracher" /> / 元
        </el-form-item>
        <el-form-item label="原价" prop="gift_amount">
          <el-input v-model="parameter.gift_amount" style="width:300px" type="number" @blur="sendchagerracher" /> / 元
        </el-form-item>
        <el-form-item label="充值次数" prop="max_times">
          <el-select v-model="parameter.max_times" placeholder="请选择">
            <el-option
              v-for="item in [{value: '一次', id: 1}, {value: '两次', id: 2},{value: '三次', id: 3}]"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { readingservice } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.date[0] == this.parameter.date[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    var rechargeamount = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (Number(this.parameter.recharge_amount) < Number(this.parameter.vip_duration) * 300) {
        callback(new Error(`活动价格范围(${this.parameter.vip_duration * 300}-5000)`))
      } else {
        callback()
      }
    }
    var rechargeamountone = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (Number(this.parameter.recharge_amount) > 5000) {
        callback(new Error('最大金额小于等于5000'))
      } else {
        callback()
      }
    }
    var giftamount = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (Number(this.parameter.gift_amount) <= Number(this.parameter.recharge_amount)) {
        callback(new Error('请输入大于活动价格的值'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        title: [
          { required: true, message: '请输入活动标题', trigger: 'blur' }
        ],
        recharge_amount: [
          { required: true, message: '请输入活动价格', trigger: 'blur' },
          { validator: rechargeamount, trigger: 'blur' },
          { validator: rechargeamountone, trigger: 'blur' }
        ],
        gift_amount: [
          { required: true, message: '请输入原价', trigger: 'blur' },
          { validator: giftamount, trigger: 'blur' }
        ],
        vip_duration: [
          { required: true, message: '请选择会员时长', trigger: 'change' }
        ],
        max_times: [
          { required: true, message: '请选择充值次数', trigger: 'change' }
        ],
        date: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ]
      },

      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      parameter: {
        stime: null, // 开始时间
        etime: null, // 结束时间
        title: null, // 标题
        recharge_amount: '', // 充值金额
        vip_duration: 1, // 会员时长
        date: [],
        gift_amount: null, // 赠送金额
        max_times: null, // 充值次数
        appoint_day: ''
      },
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2
    }
  },
  created() {

  },
  mounted() {

  },

  methods: {
    datavalue(val) {
      console.log('val', val)
      this.parameter.stime = val[0]
      this.parameter.etime = val[1]
    },

    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.parameter.stime
            par.end_time = this.parameter.etime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.parameter.appoint_day)
          }
          try {
            await readingservice({
              platform_id: this.platformid,
              activity_type: 2,
              ...par,
              activity_info: {
                name: this.parameter.title,
                // start_ts: this.parameter.stime,
                // end_ts: this.parameter.etime,
                vip_duration: this.parameter.vip_duration,
                activity_price: Number(this.parameter.recharge_amount) * 100,
                original_price: Number(this.parameter.gift_amount) * 100,
                max_times: this.parameter.max_times,
                activity_id: null,
                introduction: '',
                custom_activity_type: 2
              }
            })
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('close')
          } catch (err) {
            this.$message({
              message: err,
              type: 'warning'
            })
          }
        } else {
          false
        }
      })
    },
    chagerracher() {
      // eslint-disable-next-line eqeqeq
      if (this.parameter.recharge_amount <= 0 && this.parameter.recharge_amount != '') {
        this.parameter.recharge_amount = 1
      }
    },
    sendchagerracher() {
      // eslint-disable-next-line eqeqeq
      // if (this.parameter.gift_amount <= 0 && this.parameter.gift_amount != '') {
      //   this.parameter.gift_amount = 1
      // }
    }

  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
/deep/ .el-input__inner::-webkit-outer-spin-button,
 /deep/ .el-input__inner::-webkit-inner-spin-button {
-webkit-appearance: none;
 }
/deep/ .el-input__inner[type='number'] {
-moz-appearance: textfield;
 }

</style>

